import { render, staticRenderFns } from "./ProjetoRNDetalhamento.vue?vue&type=template&id=38c62782&"
import script from "./ProjetoRNDetalhamento.vue?vue&type=script&lang=js&"
export * from "./ProjetoRNDetalhamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports